
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import Modal from '@/components/Modal.vue';
	import SearchSVG from '@/components/SearchSVG.vue';
	import { Observer } from 'mobx-vue';
	import { Order, Patient } from '@/store/engine/openapi/generated';
	import DualButtonModal from '@/components/modals/DualButtonModal.vue';
	import { OrderWithPatient } from '@/store/DoctorStore';

	@Observer
	@Component({
		components: { DualButtonModal, Modal, SearchSVG }
	})
	export default class OrderRow extends Vue {
		@Prop({ required: true }) order?: OrderWithPatient;
		@Prop({ required: false }) privacy;
		@Prop({ required: true }) tab;
		@Prop({ required: true }) index;

		private menu: boolean = false;
		private modal: boolean = false;

		private toPrivateName(name: string) {
			return name[0] + '.';
		}

		private toPrivateId(id: string) {
			if (id.length > 5) {
				const temp = id.substr(id.length - 5);
				return id.substr(0, id.length - 5).replace(/[A-Z 0-9]/gi, '*') + temp;
			} else {
				return id;
			}
		}

		handleFocusOut() {
			this.menu = false;
		}

		private timestampToDate(val) {
			if (+val <= -2209118287000) {
				return '-';
			}
			const date = new Date(+val);
			const year = date.getUTCFullYear();
			const month = date.getUTCMonth();
			const day = date.getUTCDate();
			return month + 1 + '/' + day + '/' + year;
		}

		private lastUpdateParse(val: string) {
			try {
				let date = val.split('T')[0];
				let months = date.split('-')[1];
				let years = date.split('-')[0];
				let day = date.split('-')[2];

				let time = val.split('T')[1];
				time = time.slice(0, -1);

				let toLocalTime = new Date(months + '/' + day + '/' + years + ' ' + time.split('.')[0] + ' UTC');

				// return toLocalTime.getMonth() + 1 + '/' + toLocalTime.getDate() + '/' + toLocalTime.getFullYear() + ' ' + toLocalTime.toLocaleTimeString('en-US');
				return toLocalTime.toLocaleDateString('en-US') + ' ' + toLocalTime.toLocaleTimeString('en-US');
			} catch (e) {
				return 'unknown';
			}
		}

		private onPatientClick() {
			this.$emit('patientClick', this.order);
		}
	}
